(() => {
  const dialog = document.getElementById('mr-storewide-offer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'mulroom-offer-seen-v1';
  const interval = 30 * 24 * 60 * 60 * 1000;
  let previousFocus;
  let interacted = false;
  const remember = () => {
    try { localStorage.setItem(key, String(Date.now())); } catch {}
  };
  const show = () => {
    if (dialog.open || document.querySelector('dialog[open]')) return false;
    previousFocus = document.activeElement;
    dialog.showModal();
    document.body.classList.add('mr-offer-is-open');
    remember();
    return true;
  };
  const close = () => { if (dialog.open) dialog.close(); };
  dialog.addEventListener('close', () => {
    document.body.classList.remove('mr-offer-is-open');
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-mr-offer-open]')) show();
    if (event.target.closest('[data-mr-offer-close]')) close();
    const apply = event.target.closest('a[data-mr-offer-apply]');
    if (apply) {
      remember();
      apply.href = `/discount/MULROOM20?redirect=${encodeURIComponent(location.pathname + location.search + location.hash)}`;
    }
  });
  const markInteraction = event => {
    if (event.target instanceof Element && event.target.closest('input,select,textarea,button,a,[role="radio"]')) interacted = true;
  };
  document.addEventListener('pointerdown', markInteraction, { capture: true, passive: true });
  document.addEventListener('change', markInteraction, { capture: true });
  document.addEventListener('keydown', () => { interacted = true; }, { capture: true, once: true });
  let lastSeen = 0;
  try { lastSeen = Number(localStorage.getItem(key)) || 0; } catch {}
  if (dialog.dataset.autoOpen !== 'true' || Date.now() - lastSeen < interval) return;
  window.setTimeout(() => {
    if (!interacted && document.visibilityState === 'visible' && !document.querySelector('dialog[open],.shopify-section-group-overlay-group [open]')) show();
  }, 8000);
})();
